'use strict';

// The following region map provides a mapping between the region names that get returned by the Cloud Storage
// Validation service's 'GET /objectStorage/AZURE/account/{accountName}/region' endpoint (which is based on region
// names defined by the Azure Datacenter IP Ranges XML data set that Microsoft publishes regularly at
// https://www.microsoft.com/en-ca/download/details.aspx?id=41653) and the other seemingly newer region naming
// convention used by Azure (e.g. Azure CLI command `az account list-locations` command) and the platform.
//
// It's unclear why different region naming conventions are still in use but we need a way to map between the two
// since we're using the existing Cloud Storage Validation service endpoint to resolve Azure region names in the
// platform and the platform expects the other region name format.

var cloudStorageValidationAzureRegionMap = {
    asiaeast: 'eastasia',
    asiasoutheast: 'southeastasia',
    australiaeast: 'australiaeast',
    australiac: 'australiacentral',
    australiac2: 'australiacentral2',
    australiasoutheast: 'australiasoutheast',
    brazilsouth: 'brazilsouth',
    canadacentral: 'canadacentral',
    canadaeast: 'canadaeast',
    europenorth: 'northeurope',
    europewest: 'westeurope',
    francec: 'francecentral',
    frances: 'francesouth',
    indiacentral: 'centralindia',
    indiasouth: 'southindia',
    indiawest: 'westindia',
    japaneast: 'japaneast',
    japanwest: 'japanwest',
    koreacentral: 'koreacentral',
    koreasouth: 'koreasouth',
    uksouth: 'uksouth',
    ukwest: 'ukwest',
    uscentral: 'centralus',
    useast: 'eastus',
    useast2: 'eastus2',
    uswest: 'westus',
    uswest2: 'westus2',
    uswestcentral: 'westcentralus'
};

var cloudStorageValidationAzureRegionList = Object.keys(cloudStorageValidationAzureRegionMap);

var fromCloudStorageValidationAzureRegion = function fromCloudStorageValidationAzureRegion(cloudStorageValidationRegion) {
    return cloudStorageValidationAzureRegionMap[cloudStorageValidationRegion];
};

module.exports = {
    cloudStorageValidationAzureRegionList: cloudStorageValidationAzureRegionList,
    fromCloudStorageValidationAzureRegion: fromCloudStorageValidationAzureRegion
};